import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ImagePositionState, DEFAULT_IMAGE_POSITION } from '../../../shared/image-positioner/image-position-state';
import { FormBuilder, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import {
  NzUploadChangeParam,
  NzUploadFile,
  NzUploadXHRArgs,
} from 'ng-zorro-antd/upload';
import { UploadService } from '../../../../core/services/upload.service';
import { ItineraryService } from '../../../../core/services/itinerary.service';
import { ItineraryTemplatesService } from '../../../../core/services/itinerary-templates.service';
import { GooglePlacesService } from '../../../../core/services/google-places.service';
import { DestinationService } from '../../../../core/services/destination.service';
import { AppUtils } from '../../../../core/config/app.utils';
import { DestinationDTO } from '../../../../core/dto/destination';
import { SETTINGS } from '../../../../core/config/common.settings';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SettingService } from '../../../../core/services/setting.service';
import { LanguageService } from '../../../../core/services/language.service';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import { UserService } from '../../../../core/services/user.service';
import { OpenAiService } from '../../../../core/services/open-ai.service';
import { Subscription } from 'rxjs';
import { getSubstringAfterLastComma } from '../../../../core/ult-functions/text';
import {destinationMergeChecker} from "../../../../core/ult-functions/destination";
import { withItineraryLockSession } from '../../../../core/ult-functions/itinerary-tab-session';
import { TranslocoService } from '@ngneat/transloco';

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

@Component({
  selector: "app-add-edit-destination-content",
  templateUrl: "./add-edit-destination-content.component.html",
  styleUrls: ["./add-edit-destination-content.component.scss"]
})
export class AddEditDestinationContentComponent implements OnInit, OnDestroy {

  @Input() itinerary?: any;
  @Input() dateIndex?: any; // index of the selected Date
  @Input() mode?: any;
  @Input() destinationPlaceIDOrID?: any;
  @Input() featuredContent?: any;
  @Input() indexDay: any;
  @Input() entryType?: any;
  @Input() itineraryMode: 'itinerary' | 'template' = 'itinerary';
  @Input() sessionId?: string;

  subscription: Subscription | undefined;
  fileList: NzUploadFile[] = [];
  standaloneFileList: NzUploadFile[] = [];
  previewImage: string | undefined = "";
  previewVisible = false;
  featuredForm: any;
  listOfTagOptions: any = [];
  searchName = "";
  googlePlaceDetails: any;
  destination: any;
  images: any = [];
  standaloneImages: any = [];
  formErrors: any;
  destinationDTO = new DestinationDTO();
  tempSuggestion: any;
  type = "";
  selectedKeywordIndex: number |undefined ;
  radioValue = "";
  tempDays: any = [];

  // for the search
  listOfOption: any = [];
  selectedDest?: string;
  isImageExist?: boolean;
  effectiveDefaultImage: string = '';
  loading = false;

  contexts: any[] = [];
  title = "";
  selectedLanguages: any = [];
  languages: any = [];
  isDisplayAiButton = false;
  isCustom = false;
  isButtonLoading = false;
  isMergingEvent = false;

  protected readonly SETTINGS = SETTINGS;

  constructor(private fb: FormBuilder,
              private modal: NzModalRef,
              private message: NzMessageService,
              private uploadService: UploadService,
               private itineraryService: ItineraryService,
               private itineraryTemplatesService: ItineraryTemplatesService,
               private googlePlacesService: GooglePlacesService,
              private destinationService: DestinationService,
              private settingService: SettingService,
              private languageService: LanguageService,
              private authService: AuthService,
              private openAiService: OpenAiService,
              private modalConfirmation: NzModalService,
              private userService: UserService,
              private translocoService: TranslocoService) {

    this.formErrors = {
      body: {},
      keyword: {},
      language: {},
      keywordIndex: {},
      image: {},
    };
  }

  get activeService(): ItineraryService | ItineraryTemplatesService {
    return this.itineraryMode === 'template' ? this.itineraryTemplatesService : this.itineraryService;
  }

  ngOnInit(): void {
    this.findBrand().then();
    this.getLanguages().then();

    // when user the edit the content
    if (SETTINGS.ITINERARY_CONTENT_MODE.EDIT === this.mode) {
      this.loading = true;
      this.googlePlacesService.destinationExistGoogleDetails(this.destinationPlaceIDOrID, this.entryType).then(value => {
        this.googlePlaceDetails = value;
        this.loading = false;
      });
      this.listOfTagOptions.push(...this.dateIndex);
    } else {
      this.listOfTagOptions.push(this.dateIndex);
    }

    this.featuredForm = this.fb.group({
      body: ["", [Validators.required]],
      keyword: ["", [Validators.required]],
      language: ["", [Validators.required]],
      image: [""],
      keywordIndex: ["", [Validators.required]],
      imagePosition: [{ ...DEFAULT_IMAGE_POSITION }],
    });
    this.subscription = this.googlePlacesService.onFindPlaceDetailsChange.subscribe(async (data) => {
      if (data !== undefined) {
        if (data.exist === true) {
          this.type = "update";
          this.destinationDTO = data.destination;
          console.log(this.destinationDTO);
          this.images = this.destinationDTO.images;
          this.destinationDTO.contexts = this.getContexts(this.destinationDTO.contexts);
          this.ensureTitleForLanguage(this.destinationDTO.titles, this.itinerary.tour.language);
          this.contexts = this.destinationDTO.contexts;
          this.fileList = this.destinationDTO.images.map(
            (image: any, index: number) => ({
              uid: (index + 1).toString(),
              name: "image.png",
              status: "done",
              url: image,
            }));
          this.onChangeImageUpload(this.fileList);
          this.tempDays = this.itinerary.days.map((day: any) => {
            const destinationId = day.destination ? day.destination._id : null;
            return {
              date: day.date,
              destination: destinationId,
              remarksTips: day?.remarksTips ? day.remarksTips : "" ,
              overviewDescription: day.overviewDescription,
              isLeisureDay: day.isLeisureDay,
              isMerged: day?.isMerged || false,
              transport: day.transport,
              featuredDestination: day.featuredDestination ? day.featuredDestination : this.featuredInit(),
              standaloneImages: day?.standaloneImages ? day.standaloneImages : [],
              additionalCosts: day?.additionalCosts ? day.additionalCosts : [],

            };
          });

          this.standaloneImages = this.tempDays[this.indexDay]?.standaloneImages || [];
          this.standaloneFileList = this.standaloneImages.map(
            (image: any, index: number) => ({
              uid: (index + 1).toString(),
              name: `image${index + 1}.png`,
              status: "done",
              url: image,
            }));
          this.onChangeImageUpload(this.standaloneFileList);
          this.filterContentByLanguage(this.itinerary.tour.language);
          await this.fetchEffectiveDefaultImage();

          this.featuredForm.patchValue({
            body: this.featuredContent !== null ? this.featuredContent?.body || this.contexts[0].body : this.contexts[0].body,
            keyword: this.featuredContent !== null ? this.featuredContent?.keyword || this.contexts[0].keyword : this.contexts[0].keyword,
            language: this.featuredContent !== null ? this.featuredContent?.language || this.contexts[0].language : this.contexts[0].language,
            image: this.featuredContent?.image || this.getEffectiveDefaultImage(),
            keywordIndex: 0,
            imagePosition: this.featuredContent?.imagePosition ?? { ...DEFAULT_IMAGE_POSITION },
          });

          if (SETTINGS.ITINERARY_CONTENT_MODE.EDIT === this.mode) {
            const isMatch = this.contexts.some(ctx => ctx.body === this.featuredContent.body);
            if (isMatch) {
              this.featuredForm.patchValue({
                body: this.featuredContent !== null ? this.featuredContent.body : this.contexts[0].body,
                keyword: this.featuredContent !== null ? this.featuredContent?.keyword || this.contexts[0].keyword : this.contexts[0].keyword,
                language: this.featuredContent !== null ? this.itinerary.tour.language || this.contexts[0].language : this.contexts[0].language,
                image: this.featuredContent?.image || this.getEffectiveDefaultImage(),
                keywordIndex: "0",
                imagePosition: this.featuredContent?.imagePosition ?? { ...DEFAULT_IMAGE_POSITION },
              });
            }else{
              this.featuredForm.patchValue({
                body: this.contexts[0].body,
                keyword:  this.contexts[0].keyword,
                language:  this.contexts[0].language,
                image: this.featuredContent?.image || this.getEffectiveDefaultImage(),
                keywordIndex: "0",
                imagePosition: { ...DEFAULT_IMAGE_POSITION },
              });
            }
          } else{
            this.featuredForm.patchValue({
              body: this.featuredContent !== null ? this.featuredContent.body : this.contexts[0].body,
              keyword: this.featuredContent !== null ? this.featuredContent?.keyword || this.contexts[0].keyword : this.contexts[0].keyword,
              language: this.featuredContent !== null ? this.itinerary.tour.language || this.contexts[0].language : this.contexts[0].language,
              image: this.featuredContent?.image || this.getEffectiveDefaultImage(),
              keywordIndex: "0",
              imagePosition: this.featuredContent?.imagePosition ?? { ...DEFAULT_IMAGE_POSITION },
            });
          }

          // setting the radio value and keyword index of existing context
          this.radioValue = "0";
          this.selectedKeywordIndex = this.findDestinationContextsIndex(this.contexts[0].body);


        } else if (data.exist === false) {
          this.isDisplayAiButton = true;
          this.type = "new";
          this.fileList = [];
          this.images = [];
          this.title = this.tempSuggestion.structuredFormat.mainText.text;
          this.destinationDTO.contexts = [];
          this.destinationDTO.titles = this.generateTitles(this.title, 1);
          this.destinationDTO.location = data.location;
          this.destinationDTO.apiId = data.id;
          this.destinationDTO.active = true;
          this.destinationDTO.images = [];
          this.destinationDTO.contexts.push(this.contextInit());
          this.filterContentByLanguage(this.itinerary.tour.language);
          this.onChangeImageUpload(this.fileList);
          this.tempDays = this.itinerary.days.map((day: any) => {
            const destinationId = day.destination ? day.destination._id : null;
            return {
              date: day.date,
              destination: destinationId,
              isLeisureDay: day.isLeisureDay,
              isMerged: day?.isMerged || false,
              overviewDescription: day.overviewDescription,
              remarksTips: day?.remarksTips ? day.remarksTips : "" ,
              transport: day.transport,
              featuredDestination: day.featuredDestination ? day.featuredDestination : this.featuredInit(),
              standaloneImages: day?.standaloneImages ? day.standaloneImages : [],
              additionalCosts: day?.additionalCosts ? day.additionalCosts : [],
            };
          });
          this.standaloneImages = [];
          this.standaloneFileList = [];
          this.onChangeImageUpload(this.fileList);
          this.featuredForm.patchValue({
            body: this.contexts[0].body,
            keyword: this.contexts[0].keyword,
            language: this.contexts[0].language,
            image: "",
            keywordIndex: "0",
            imagePosition: { ...DEFAULT_IMAGE_POSITION },
          });
          this.radioValue = "0";
          this.selectedKeywordIndex = 0;
        }
      }

    });

    this.featuredForm.valueChanges.subscribe((form: any) => {
      // settings specify form values to contexts and feature
      if (this.selectedKeywordIndex !== undefined) {
        this.destinationDTO.contexts[this.selectedKeywordIndex].body = form?.body;
      }

      this.tempDays[this.dateIndex].featuredDestination = this.featuredForm.getRawValue();
      this.formErrors = AppUtils.getFormErrors(
        this.featuredForm,
        this.formErrors
      );
    });

    this.featuredForm.get("body")?.valueChanges.subscribe( (value: any) => {
      if (this.featuredForm.get("body")?.dirty) {
        this.isCustom = true;
      }
    });

    this.uploadService.onUploadedFileChange.subscribe(value => {
      this.loading = false;
    });

  }

  handlePreview = async (file: NzUploadFile | any): Promise<void> => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  customUploadReq = (item: NzUploadXHRArgs | any) => {
    this.loading = true;
    const formData = new FormData();
    formData.append("file", item.file);
    return this.uploadService.uploadFile(formData, item);
  }

  handleChange(event: NzUploadChangeParam): any {
    const url = event?.file?.response?.url;
    if (event?.type === "success" && url) {
      this.addUploadImage(url);
      this.featuredForm.patchValue({image: url});
      this.syncUploadFileList();
    }
  }

  onRemove = (item: NzUploadXHRArgs | any) => {
    this.removeUploadImage(item.url);
    return true;
  }

  setMediaUploadHeaders = (file: any) => {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    };
  }

  searchDestination(value: string): void {
    if (value !== "") {
      this.googlePlacesService.postAutoComplete({
        input: value,
        primaryTypes: ["locality", "natural_feature"]
      }).then(res => {

        this.listOfOption = res?.suggestions || [];
      });

      this.destinationService.getDestinationByName({name: value}).then(res => {
        this.listOfOption = [...this.listOfOption, ...res];
      });
    }
  }

  async selectedDestination(data: any): Promise<any> {
    try {
      this.tempSuggestion = data;
      if (data.entryType === SETTINGS.ENTRY_TYPES.MANUAL) {
        this.googlePlaceDetails = await this.googlePlacesService.destinationExistGoogleDetails(data.destinationId,
          SETTINGS.ENTRY_TYPES.MANUAL);
      } else {
        this.googlePlaceDetails = await this.googlePlacesService.destinationExistGoogleDetails(data.placeId, SETTINGS.ENTRY_TYPES.GOOGLE);
      }
    } catch (e) {
      console.log(e);
      this.message.error(this.translocoService.translate('itineraries.destination.messages.somethingWentWrong'));
    }
  }

  async addDestination(): Promise<any> {
    this.isButtonLoading = true;
    try {
      this.listOfTagOptions.sort((a: number, b: number) => a - b);
      if (this.type === "new") {
        const extractedCountry = getSubstringAfterLastComma(this.tempSuggestion.structuredFormat.secondaryText.text);
        const images = this.getNewDestinationImages();
        const defaultImage = this.featuredForm.get('image')?.value || images[0] || '';
        const payload = {
          tableTitle: this.tempSuggestion.text.text,
          city: this.tempSuggestion.structuredFormat.mainText.text,
          country: extractedCountry,
          titles: this.destinationDTO.titles,
          location: this.googlePlaceDetails.location,
          apiId: this.tempSuggestion.placeId,
          contexts: this.destinationDTO.contexts,
          images,
          defaultImage,
          entryType: SETTINGS.ENTRY_TYPES.GOOGLE,
          active: true
        };
        await this.destinationService.createDestinationModel(payload).then(res => {
          // this.tempDays.map((day: any, index: any) => {
          //   if (this.listOfTagOptions.includes(index)) {
          //     this.tempDays[index].destination = res._id;
          //     this.tempDays[index].featuredDestination = this.featuredForm.getRawValue();
          //   }
          // });
          this.listOfTagOptions.forEach((num: number, idx: number) => {
            this.tempDays[num].destination = res._id;
            this.tempDays[num].isMerged = false;
            this.tempDays[num].standaloneImages = [];
            this.tempDays[num].featuredDestination = this.featuredForm.getRawValue();
          });

          this.tempDays = this.isMergingEvent ?  destinationMergeChecker(this.tempDays) : this.tempDays;

        });

        await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, days: this.tempDays}, this.sessionId!));
        this.isButtonLoading = false;
        this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ADD_SUCCESS);
      } else {
        if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
          await this.onEdit(this.listOfTagOptions);
        }else {
          await this.onEdit(this.listOfTagOptions);
        }
      }

    } catch (e) {
      this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ERROR);
    }
  }

  handleCancel(): void {
    this.modal.close();
  }

  selectedKeyword(tempBody: any): void {
    // find the index of destinationDTO.contexts
    this.selectedKeywordIndex = this.findDestinationContextsIndex(tempBody);
    this.featuredForm.patchValue({
      body: tempBody,
      keyword: this.featuredForm.controls.keyword.value,
      keywordIndex: this.selectedKeywordIndex,
      language: this.itinerary.tour.language,
    });
  }
  getIcon(data: any): string {
    if (data?.isQueried){
      return  "text-select";
    }else{
      return  data.placeId !== "" ? "globe" : "blocks";
    }
  }

  getSelectedImage(): any {
    return this.featuredForm.controls.image.value;
  }

  onChangeImageUpload(file: any): void {
    if (file.length >= 1) {
      this.isImageExist = true;
    } else if (file.length === 0) {
      this.isImageExist = false;
    }
  }

  getUploadImages(): string[] {
    return this.type === "new" ? this.images : this.standaloneImages;
  }

  private addUploadImage(url: string): void {
    if (this.type === "new") {
      if (!this.images.includes(url)) {
        this.images.push(url);
      }
      this.destinationDTO.images = [...this.images];
      return;
    }
    if (!this.standaloneImages.includes(url)) {
      this.standaloneImages.push(url);
    }
  }

  private removeUploadImage(url: string): void {
    if (this.type === "new") {
      this.images = this.images.filter((x: string) => x !== url);
      this.destinationDTO.images = [...this.images];
      return;
    }
    this.standaloneImages = this.standaloneImages.filter((x: string) => x !== url);
  }

  private syncUploadFileList(): void {
    const source = this.getUploadImages();
    const mapped = source.map((image: string, index: number) => ({
      uid: (index + 1).toString(),
      name: `image${index + 1}.png`,
      status: "done" as const,
      url: image,
    }));
    if (this.type === "new") {
      this.fileList = mapped;
    } else {
      this.standaloneFileList = mapped;
    }
    this.onChangeImageUpload(mapped);
  }

  private getNewDestinationImages(): string[] {
    return [...new Set((this.destinationDTO?.images || []).filter(Boolean))];
  }

  async findBrand(): Promise<any> {
    const user = await this.authService.getLoggedInUser();
    const brand = await this.settingService.findBrand(user.userId);
    this.selectedLanguages = brand?.selectedLanguages || [];
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
  }

  filterContentByLanguage(lang: string): void {
    this.title = this.destinationDTO.titles
      .filter(obj => obj.language === lang)
      .map(obj => obj.name)
      .join(", ");
    this.contexts = this.destinationDTO.contexts
      .filter(obj => obj.language === lang);

    // Context don't exist, by default context will be added to local variable and dto
    if (this.contexts.length === 0) {
      this.isDisplayAiButton = true;
      this.contexts.push(this.contextInit());
      this.destinationDTO.contexts.push(this.contextInit());
    }
  }

  generateTitles(tempName?: string, toggle?: number): any {
    if (toggle === 1) {
      return this.selectedLanguages.map((languageCode: any) => {
        return {name: tempName, language: languageCode};
      });
    }

    if (toggle === 2) {
      return this.selectedLanguages.map((languageCode: any, index: number) => {
        return {name: this.destinationDTO.titles[index].name, language: languageCode};
      });
    }

  }

  contextInit(): any {
    return {
      keyword: this.translocoService.translate('itineraries.destination.form.defaultKeyword'),
      body: this.translocoService.translate('itineraries.destination.form.defaultBody'),
      type: SETTINGS.CONTENT_TYPES.TYPED,
      language: this.itinerary.tour.language,
    };
  }

  findDestinationContextsIndex(tempBody: string): number {
    return this.destinationDTO.contexts.findIndex(
      (context) => context.body === tempBody && context.keyword === this.featuredForm.controls.keyword.value
    );
  }

  featuredInit(): any {
    return {
      body: "",
      keyword: "",
      image: "",
      keywordIndex: "0",
      imagePosition: { ...DEFAULT_IMAGE_POSITION },
    };
  }

  get currentImagePosition(): ImagePositionState {
    return this.featuredForm.get('imagePosition')?.value ?? { ...DEFAULT_IMAGE_POSITION };
  }

  onImagePositionChange(state: any): void {
    console.log(state);
    this.featuredForm.patchValue({ imagePosition: state as ImagePositionState }, { emitEvent: false });
  }

  async getGeneratedContent(queryData: any): Promise<void> {
    this.loading = true;
    const payload = `Generate a captivating description of '${queryData.name}' between 80-100 words in  '${queryData.language}'.
        , starting with a unique word that has not been used before. Highlight aspects like local culture, delicious food, and stunning scenic spots, creating an engaging and travel-inspiring tone to entice visitors.
        Provide only one tag describes the best for the generated content Tag should start with # and tag should be in english no matter what language it is.`;
    try {
      const value = await this.openAiService.askChatGPT({query: payload});
      this.breakdownAndPatchContent(value.choices[0].message.content);
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  private breakdownAndPatchContent(text: string): void {
    // breakdown the spaces
    const lines = text.split("\n");

    const contentLines: string[] = [];
    const tags: string[] = [];

    // Loop through each line
    lines.forEach(line => {
      const trimmedLine = line.trim();
      if (trimmedLine.startsWith("#")) {
        // Split by whitespace to handle multiple tags separated by spaces
        const lineTags = trimmedLine.split(/\s+/).map(tag => tag.substring(1));
        tags.push(...lineTags);
      } else {
        contentLines.push(line);
      }
    });

    // Join content lines into a single string
    const content = contentLines.join(" ").trim();

    // Join tags array into a comma-separated string
    const tagsString = tags.join(", ");

    this.featuredForm.patchValue({body: content, keyword: tagsString});
    this.contexts[0] = {
      body: content,
      keyword: tagsString,
      language: this.contexts[0].language,
      image: this.contexts[0].image,
      keywordIndex: this.contexts[0].keywordIndex,
    };

    this.destinationDTO.contexts[0] = this.contexts[0];
  }

  removeSelectedImage(): void {
    this.featuredForm.controls.image.value = '';
  }

  private getEffectiveDefaultImage(): string {
    return this.effectiveDefaultImage || this.destinationDTO?.defaultImage || this.images?.[0] || '';
  }

  private async fetchEffectiveDefaultImage(): Promise<void> {
    if (!this.destinationDTO?._id) {
      this.effectiveDefaultImage = this.destinationDTO?.defaultImage || this.images?.[0] || '';
      return;
    }
    try {
      const pref = await this.userService.getContentImagePreference('destinations', this.destinationDTO._id);
      this.effectiveDefaultImage = pref?.imageUrl || this.destinationDTO?.defaultImage || this.images?.[0] || '';
    } catch {
      this.effectiveDefaultImage = this.destinationDTO?.defaultImage || this.images?.[0] || '';
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  deleteImage(img: any): void {
    this.removeUploadImage(img);
    if (this.getUploadImages().length === 0) {
      this.featuredForm.patchValue({image: ""});
      this.isImageExist = false;
    }
  }
  cancel(): void {
  }

  getContexts(mainContexts: any[]): any[] {
    const contexts = [...mainContexts];
    if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
      if (this.featuredContent?.keyword === "Custom"){
        contexts.push(
          {
            keyword: this.featuredContent.keyword,
            body: this.featuredContent.body,
            language: this.featuredContent.language,
            type: "typed"
          }
        );
        return contexts;
      }
    }

    return contexts;
  }

  ensureTitleForLanguage(
    titles: { name: string; language: string; _id?: any }[],
    language: string,
  ): void {
    const exists = titles.some(title => title.language === language);
    if (!exists) {
      this.destinationDTO.titles.push({ name: this.destinationDTO.city, language });
    }
  }

 async onEdit(listOfTagOptions: number[]): Promise<void> {
    const featureFormValue = this.featuredForm.getRawValue();
    if (featureFormValue.keyword === "Custom") {
      this.isCustom = true;
    }

    // this.tempDays.map((day: any, index: any) => {
    //   if (listOfTagOptions.includes(index)) {
    //     this.tempDays[index].destination = this.destinationDTO._id;
    //     this.tempDays[index].featuredDestination = {
    //       isCustom: this.isCustom,
    //       ...featureFormValue,
    //       keyword: this.isCustom ? "Custom" : featureFormValue.keyword };
    //   }
    // });

    listOfTagOptions.forEach((num: number, idx: number) => {
      this.tempDays[num].destination = this.destinationDTO._id;
      this.tempDays[num].isMerged = false;
      this.tempDays[num].standaloneImages =  this.standaloneImages ? this.standaloneImages : [];
      this.tempDays[num].featuredDestination = {
        isCustom: this.isCustom,
        ...featureFormValue,
        keyword: this.isCustom ? "Custom" : featureFormValue.keyword };
    });

    this.tempDays = this.isMergingEvent ?  destinationMergeChecker(this.tempDays) : this.tempDays;

    // destruct contexts array
    const {contexts, ...rest} = this.destinationDTO;
    await this.destinationService.updateDestinationItin(rest);
    await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, days: this.tempDays}, this.sessionId!));
    this.isButtonLoading = false;
    this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.EDIT_SUCCESS);
  }

  async determineMerge(arr: any): Promise<void> {
    if (arr.length !== 0 && arr.length > 1) {
      // const set = new Set(arr);
      const min = Math.min(...arr);
      const max = Math.max(...arr);
      // if it’s continuous, max − min must be exactly length−1
      const result = max - min === arr.length - 1;
      if (result) {
        this.mergePopConfirm();
      }else{
        this.isMergingEvent = false;
        await this.addDestination();
      }
    }else{
      this.isMergingEvent = false;
      await this.addDestination();
    }
  }

  mergePopConfirm(): void {
    this.modalConfirmation.confirm({
      nzClosable: false,
      nzTitle: this.translocoService.translate('itineraries.destination.mergeModal.title'),
      nzContent: this.translocoService.translate('itineraries.destination.mergeModal.content'),
      nzOkText: this.translocoService.translate('itineraries.destination.mergeModal.ok'),
      nzCancelText: this.translocoService.translate('itineraries.destination.mergeModal.cancel'),
      nzOnOk: async () => {
        this.isMergingEvent = true;
        await this.addDestination();
      },
      nzOnCancel: async () => {
        this.isMergingEvent = false;
        await this.addDestination();
      }
    });
  }
}
